"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _rumEvent = require("../types/rum-event");
var _client = _interopRequireDefault(require("../model/client"));
var _is = require("../utils/is");
var Shell = exports["default"] = /*#__PURE__*/function () {
  function Shell(config) {
    this.client = void 0;
    this.client = new _client["default"]();
    if (config && this.init) {
      this.init(config);
    }
  }

  /**
   * 初始化
   */
  var _proto = Shell.prototype;
  _proto.sendEvent = function sendEvent(payload) {
    if (this.client) {
      this.client.sendEvent(payload);
    }
  }

  /**
   * get config
   */;
  _proto.getConfig = function getConfig() {
    if (this.client) {
      return this.client.getContext().getConfig();
    }
  }

  /**
   * set config
   */;
  /**
   * 自定义事件上报
   */
  _proto.sendCustom = function sendCustom(payload) {
    if (!payload.name || !payload.type) {
      return;
    }
    var data = (0, _extends2["default"])({}, payload, {
      event_type: _rumEvent.RumEventType.CUSTOM
    });
    this.sendEvent(data);
  };
  /**
   * 自定义视图上报
   */
  _proto.sendView = function sendView(payload) {
    if (!(0, _is.isObject)(payload)) {
      return;
    }
    if (!payload.type) {
      payload.type = 'custom';
    }
    if (payload.type === 'custom') {
      var n = 0;
      ['t1', 't2', 't3'].forEach(function (key) {
        if (!(0, _is.isNumber)(payload[key])) {
          delete payload[key];
        }
        key in payload && n++;
      });
      if (n === 0) return;
    }
    var data = (0, _extends2["default"])({}, payload, {
      event_type: _rumEvent.RumEventType.VIEW
    });
    this.sendEvent(data);
  };
  /**
   * 自定义异常上报
   */
  _proto.sendException = function sendException(payload) {
    if (!payload.name || !payload.message) {
      return;
    }
    var name = payload.name,
      message = payload.message,
      stack = payload.stack;
    var data = (0, _extends2["default"])({
      times: 1,
      name: name,
      message: message,
      stack: stack
    }, payload, {
      event_type: _rumEvent.RumEventType.EXCEPTION,
      type: 'custom',
      source: 'custom'
    });
    this.sendEvent(data);
  };
  /**
   * 自定义资源上报
   */
  _proto.sendResource = function sendResource(payload) {
    if (!payload.name || !payload.type || !(0, _is.isNumber)(payload.duration)) {
      return;
    }
    var data = (0, _extends2["default"])({
      times: 1
    }, payload, {
      event_type: _rumEvent.RumEventType.RESOURCE
    });
    this.sendEvent(data);
  };
  return Shell;
}();